export default __webpack_public_path__ + "static/media/php.12412c19.png";